/**
 * Деньги журнала.
 *
 * ГЛАВНОЕ ПРАВИЛО: null — это НЕ ноль и не «ошибка загрузки». Сервер гасит priceMinor
 * и prepaidMinor целиком, когда деньги этому человеку не показываются (право finance.view
 * либо настройка салона «Деньги видны мастеру», 4-Б12). Поэтому интерфейсу достаточно
 * проверить null и не рисовать блок ВОВСЕ — прочерк на месте суммы читается как «ноль
 * рублей» и порождает вопрос «почему визит бесплатный», которого не существует.
 *
 * Суммы приходят в копейках целым числом: рубль с копейками в double — это способ
 * получить 2499,9999999 в чеке.
 */

const RUB = new Intl.NumberFormat("ru-RU", {
  style: "currency",
  currency: "RUB",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** «1 800,00 ₽». Разделитель разрядов — неразрывный пробел, его ставит Intl. */
export function formatMoney(minor: number): string {
  return RUB.format(minor / 100)
}

/**
 * Остаток к оплате: цена минус предоплата.
 *
 * Отдельного поля в API нет (CabinetAppointmentView отдаёт priceMinor и prepaidMinor),
 * поэтому остаток считается здесь — и только когда видны ОБА слагаемых. Считать остаток
 * от погашенной предоплаты значит показать «остаток равен всей сумме» там, где на самом
 * деле половина уже внесена.
 */
export function remainderMinor(
  priceMinor: number | null,
  prepaidMinor: number | null,
): number | null {
  if (priceMinor === null || prepaidMinor === null) return null
  return Math.max(priceMinor - prepaidMinor, 0)
}
